export default class Storage {
  getData() {
    throw new Error("getData method must be implemented");
  }

  setData() {
    throw new Error("setData method must be implemented");
  }
}
